export default __webpack_public_path__ + "static/media/assemblySimCover.fdf2edf2.jpg";